export enum LocationType {
    HQ = "HQ",
    Branch = "Branch",
    Internal = "Internal",
}
